/*
/assetss/wpx-random-products.js has been inserted inside /layout/theme.liquid

/section/featured-collection-grid.liquid 
on line 5 {%- assign collection = collections[section.settings.collection] -%} has been changed to {%- assign collection = collections[section.settings.collection]
*/

document.addEventListener('DOMContentLoaded', function() {
  // Select the container with the given ID
  const container = document.getElementById('products-template--24412809429318__featured_collection_grid_4cGAWF');
  
  if (container) {
    // Get all product card elements inside the container
    const productCards = container.querySelectorAll('hdt-card-product');
    
    // Calculate how many products need to be removed to leave exactly 18
    const numToRemove = productCards.length - 18;
    
    // Ensure we only proceed if there are more than 18 products
    if (numToRemove > 0) {
      // Convert the NodeList to an array to shuffle
      const productCardsArray = Array.from(productCards);
      
      // Shuffle the product cards array randomly using the Fisher-Yates algorithm
      for (let i = productCardsArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [productCardsArray[i], productCardsArray[j]] = [productCardsArray[j], productCardsArray[i]]; // Swap elements
      }

      // Remove the randomly selected products to leave exactly 18
      for (let i = 0; i < numToRemove; i++) {
        productCardsArray[i].remove();
      }
    }
  }
});